export const selectDisplayName = (value, preferDbaName) =>
  value.dbaName && preferDbaName ? value.dbaName : value.payorName;
